import { useSelector } from 'react-redux';
import { RootState, AppDispatch, useAppDispatch } from '../state/store';
import {
  advancedAccessKeySlice,
  AdvancedAccesskeyState,
  callAdvancedSerialCetificationAPI,
} from '../state/slice/advancedAccesskeySlice';

import {
  standardAccessKeySlice,
  StandardAccessKeyState,
  callStandardSerialCetificationAPI,
} from '../state/slice/standardAccessKeySlice';
import { SerialCertificationApiRequestParam } from '../types/apis/serialCertificationApi';
import elmerProductType, {
  ELMER_PRODUCT_TYPE_NAME,
} from '../utils/productType';

// 返す型が複雑すぎるため、ルールを無効化。（長すぎて、逆に読みにくいため）
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useAccessKey = () => {
  const dispatch: AppDispatch = useAppDispatch();

  // ADVANCEDのアクセスキー
  const { advancedAccesskey } = useSelector<RootState, AdvancedAccesskeyState>(
    (state) => state.advancedAccessKey,
  );
  const { resetAdvancedAccesskey } = advancedAccessKeySlice.actions;

  // STANDARDのアクセスキー
  const { standardAccesskey } = useSelector<RootState, StandardAccessKeyState>(
    (state) => state.standardAccessKey,
  );

  const { resetStandardAccesskey } = standardAccessKeySlice.actions;

  const accessKey = (): string => {
    const type = elmerProductType();
    switch (type) {
      // ADVANCED
      case ELMER_PRODUCT_TYPE_NAME.ADVANCED:
        return advancedAccesskey;

      // STANDARD
      case ELMER_PRODUCT_TYPE_NAME.STANDARD:
        return standardAccesskey;

      default:
        return advancedAccesskey;
    }
  };

  const callSerialCetificationAPI = (
    params: SerialCertificationApiRequestParam,
  ) => {
    const type = elmerProductType();
    switch (type) {
      // ADVANCED
      case ELMER_PRODUCT_TYPE_NAME.ADVANCED:
        return dispatch(callAdvancedSerialCetificationAPI(params));

      // STANDARD
      case ELMER_PRODUCT_TYPE_NAME.STANDARD:
        return dispatch(callStandardSerialCetificationAPI(params));

      default:
        return dispatch(callAdvancedSerialCetificationAPI(params));
    }
  };

  const reset = () => {
    const type = elmerProductType();
    switch (type) {
      // ADVANCED
      case ELMER_PRODUCT_TYPE_NAME.ADVANCED:
        return dispatch(resetAdvancedAccesskey());

      // STANDARD
      case ELMER_PRODUCT_TYPE_NAME.STANDARD:
        return dispatch(resetStandardAccesskey());

      default:
        return dispatch(resetAdvancedAccesskey());
    }
  };

  return {
    accessKey: accessKey(),
    callSerialCetificationAPI,
    reset,
  };
};

export default useAccessKey;
